import React from "react";
import { Award, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { chipAffordanceClasses, chipSizeClasses } from "./chip.styles";

interface CertificationChipProps {
	name: string;
	/** "md" (detail/settings pages, default) or "sm" (compact, for list-view rows). */
	size?: "md" | "sm";
	title?: string;
	className?: string;
	/** Small trailing adornment rendered after the name (e.g. an auto-derived marker). */
	indicator?: React.ReactNode;
	/** When set, a small ✕ is rendered inside the chip (e.g. removable requirement). */
	onRemove?: () => void;
	removeDisabled?: boolean;
}

/**
 * The standard certification label: a white, gray-bordered pill with a leading
 * award icon — the certification counterpart of {@link TagChip}, matching the
 * consultant competence tab rendering.
 */
const CertificationChip = ({
	name,
	size = "md",
	title,
	className,
	indicator,
	onRemove,
	removeDisabled,
}: CertificationChipProps) => (
	<span
		title={title}
		className={cn(
			"inline-flex max-w-full items-center truncate rounded border border-solid border-border-strong bg-white font-medium text-gray-900",
			chipSizeClasses(size),
			onRemove && "pr-1",
			className
		)}
	>
		<Award size={size === "sm" ? 11 : 14} className="shrink-0" />
		<span className="truncate">{name}</span>
		{indicator}
		{onRemove && (
			<button
				type="button"
				onClick={onRemove}
				disabled={removeDisabled}
				aria-label={`Ta bort ${name}`}
				title="Ta bort"
				className={cn(
					chipAffordanceClasses,
					"rounded border-0 bg-transparent text-current opacity-60 hover:bg-black/10 hover:opacity-100 disabled:pointer-events-none"
				)}
			>
				<X size={13} />
			</button>
		)}
	</span>
);

export default CertificationChip;
